<template>
  <tr>
    <td class="w-50">
      {{ row.category }}
    </td>
    <td class="w-50">
      <div class="d-flex gap-6 align-items-start">
        <div ref="checkinReport" class="w-100" />
        <div class="d-flex flex-column gap-1">
          <span :class="{ 'text-muted': row.data[0] === 0 }">{{ row.data[0] }}</span>
          <span :class="{ 'text-muted': row.data[1] === 0 }">{{ row.data[1] }}</span>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import Highcharts from 'highcharts'

const colors = ['#377DFF', '#BDC5D1']

export default {
  props: {
    row: { type: Object, required: true }
  },
  mounted() {
    if (this.chart) this.chart.destroy()

    this.chart = Highcharts.chart(this.$refs.checkinReport, {
      alignTicks: false,
      title: false,
      chart: {
        height: 48,
        type: 'bar',
        margin: [0, 0, 0, 0]
      },
      credits: { enabled: false },
      legend: { enabled: false },
      xAxis: {
        labels: { enabled: false }
      },
      yAxis: {
        visible: false
      },
      plotOptions: {
        bar: {
          borderRadius: 2,
          pointWidth: 16,
          groupPadding: 0,
          pointPadding: 0.1
        }
      },
      series: [{
        name: this.row.category,
        data: this.row.data.map((val, ind) => ({
          x: ind,
          y: val,
          color: colors[ind]
        }))
      }],
      tooltip: {
        backgroundColor: '#535c65',
        borderRadius: 4,
        borderWidth: 0,
        padding: 8,
        style: {
          fontSize: '14px',
          color: '#fff'
        },
        useHTML: true,
        shadow: false,
        formatter() {
          return `${this.series.name}: <b>${this.point.y}</b>`
        }
      }
    })
  }
}
</script>
